export {ButtonPrimitiveModule} from './button-primitive.module';
export * from './button-primitive.component';
